import { useEffect } from 'react';

const useMobileBackButton = (isOpen, onClose) => {
  useEffect(() => {
    const handlePopState = () => {
      // console.log('Back button pressed...');
      if (isOpen) {
        // console.log('... closing modal ...');
        onClose();
      }
    };

    if (isOpen) {
      // console.log('Pushing new state to history for modal...');
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      // console.log('Cleaning up modal state...');
      window.removeEventListener('popstate', handlePopState);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
};

export default useMobileBackButton;